<div class="main-container">
    <div class="header-container">
        <p *ngIf="supplierAddress?.Street1" i18n="@@09f19a1d7e6de05e08a73d9910ec74a45f9a611e" t="09f19a1d7e6de05e08a73d9910ec74a45f9a611e">Edit Address</p>
        <p *ngIf="!supplierAddress?.Street1" i18n="@@AddAddress" t="AddAddress">Add Address</p>
    </div>
    <address-edit #addressEdit [tsl-supplierCode]="supplierCode" [tsl-requiredDocuments]="requiredDocuments"
        [tsl-isReactivation]="isReactivation"
        [tsl-initialValue]="supplierAddress" [tsl-readOnly]="readOnly"
        [tsl-addressTypes]="addressTypes$ | async" [tsl-countries]="countries"
        [tsl-defaultAddressTypeName]="supplierAddressType" [tsl-generalSettings]="settings$ | async"
        [tsl-hideSaveButton]="true" [tsl-hideContactDocumentSection]="hideContactDocumentSection"
        (tsl-onSave)="addressFormSubmit($event.supplierAddress)" (tsl-onSaveError)="setErrorMessage($event.errorMessage)">
    </address-edit>
    <div class="button-container">
        <button class="action-btn" tsl-button size="small" color="black" unfilled (click)="onClose()"
            i18n="@@Cancel" t="Cancel">Cancel</button>
        <button *ngIf="!readOnly" class="action-btn" tsl-button size="small" color="blue" filled (click)="onSubmit()"
            i18n="@@Submit" t="Submit">Submit</button>
    </div>
</div>